import React, { Fragment, useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ChatStatus from "../../Components/Admin/Chat/ChatStatus";
import Chatting from "../../Components/Admin/Chat/Chatting";
import ChatAppContext from "../../Chat";

/**
 * Opens the thread selected from Support Tickets (navigate with state.openChatId or ?chat_id=).
 */
function AdminChatOpenFromTicket() {
  const location = useLocation();
  const navigate = useNavigate();
  const { members, memberLoading, changeChat } = useContext(ChatAppContext) || {};
  const openedForKey = useRef(null);

  useEffect(() => {
    openedForKey.current = null;
  }, [location.key]);

  useEffect(() => {
    if (memberLoading) return;
    const fromState = location.state?.openChatId;
    const fromQuery = new URLSearchParams(location.search || "").get("chat_id");
    const raw = fromState != null && fromState !== "" ? fromState : fromQuery;
    if (raw == null || raw === "") return;

    const id = Number(raw);
    if (!Number.isFinite(id) || id < 1) return;

    const key = `${location.key || "default"}-${id}`;
    if (openedForKey.current === key) return;

    const m = (members || []).find((x) => Number(x.chat_id) === id);
    if (m) {
      changeChat({ ...m, unread_msg_count: 0 });
      openedForKey.current = key;
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, members, memberLoading, changeChat, navigate]);

  return null;
}

const AdminChatPage = () => {
  const { selectedUser } = useContext(ChatAppContext) || {};
  const chatSubtitle =
    selectedUser?.chat_type === "support"
      ? "Support conversations (private)"
      : "Jobseeker & recruiter messages";

  return (
    <Fragment>
      <AdminChatOpenFromTicket />
      <Breadcrumbs mainTitle="Chats" title={chatSubtitle} />
      <Container fluid={true}>
        <Row>
          <Col className="call-chat-sidebar">
            <Card>
              <CardBody className="chat-body" style={{ padding: "15px" }}>
                <ChatStatus />
              </CardBody>
            </Card>
          </Col>
          <Col className="call-chat-body">
            <Card>
              <CardBody className="p-0">
                <Chatting />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AdminChatPage;
